import React from 'react';

import { Input, Section } from '@components';

type ColumnStyleFieldsProps = {
  style?: DynamicColumnFieldStyle | null;
  onUpdate: (style: DynamicColumnFieldStyle) => void;
};

const ColumnStyleFields: React.FC<ColumnStyleFieldsProps> = ({
  style,
  onUpdate,
}) => {
  const handleUpdate = (key: keyof DynamicColumnFieldStyle, value: string) => {
    onUpdate({
      ...style,
      [key]: value || null,
    });
  };

  return (
    <Section
      title="Field Style"
      subtitle="Customize the appearance of this column"
    >
      <div className="flex flex-col gap-y-lg">
        <div className="flex flex-row gap-md">
          <div className="flex-1">
            <label className="text-small text-textLight font-normal mb-xs block">
              Text Color
            </label>
            <Input
              value={style?.color || ''}
              onChange={val => handleUpdate('color', val)}
              placeholder="#000000"
              withBorder
            />
          </div>
          <div className="flex-1">
            <label className="text-small text-textLight font-normal mb-xs block">
              Font Size
            </label>
            <Input
              value={style?.fontSize || ''}
              onChange={val => handleUpdate('fontSize', val)}
              placeholder="14px, 1.2rem"
              withBorder
            />
          </div>
        </div>

        <div className="flex flex-row gap-md">
          <div className="flex-1">
            <label className="text-small text-textLight font-normal mb-xs block">
              Font Weight
            </label>
            <Input
              value={style?.fontWeight || ''}
              onChange={val => handleUpdate('fontWeight', val)}
              placeholder="normal, bold, 600"
              withBorder
            />
          </div>
          <div className="flex-1">
            <label className="text-small text-textLight font-normal mb-xs block">
              Background Color
            </label>
            <Input
              value={style?.backgroundColor || ''}
              onChange={val => handleUpdate('backgroundColor', val)}
              placeholder="#ffffff"
              withBorder
            />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default ColumnStyleFields;
